import './style.scss';
import { Caption } from 'views/mutual/caption';
import { NotificationList } from './module/notificationList';
import { NotificationListPageProps, useNotificationListPage } from './hooks';
import { NotificationDeliveryTarget, NotificationDeliveryTargetMap } from 'constants/notice';
import { Pagination } from 'views/mutual/pagination';
import { Tabs } from 'views/mutual/tabs';
import { useLocation } from 'react-router-dom';
import { PagePath } from 'constants/pagePath';
import { useState } from 'react';
import { ComponentControl } from 'views/mutual/componentControl';

// deliveryTargetを詳細から戻ってきた場合に保持する
export type NoticeLocationState = {
  deliveryTarget: NotificationDeliveryTarget;
};

export const Notice = () => {
  const location = useLocation();
  const locationState = location.state as NoticeLocationState;
  const [selectedTabIndex, setSelectedIndex] = useState(
    locationState?.deliveryTarget === NotificationDeliveryTarget.Personal ? 1 : 0,
  );

  return (
    <div className="notice">
      <Tabs
        selectedIndex={selectedTabIndex}
        onSelect={setSelectedIndex}
        tabLists={[
          { title: NotificationDeliveryTargetMap[NotificationDeliveryTarget.All].name },
          { title: NotificationDeliveryTargetMap[NotificationDeliveryTarget.Personal].name },
        ]}
        tabContents={[
          <NotificationListPage deliveryTarget={NotificationDeliveryTarget.All} />,
          <NotificationListPage deliveryTarget={NotificationDeliveryTarget.Personal} />,
        ]}
      />
    </div>
  );
};

export const NotificationListPage = (props: NotificationListPageProps) => {
  const { notificationList, currentPage, setCurrentPage, perPageCount } = useNotificationListPage(props);

  return (
    <>
      <div className="noticeList">
        <Caption label={NotificationDeliveryTargetMap[props.deliveryTarget as NotificationDeliveryTarget].name} />
        <ComponentControl
          componentName={NotificationList}
          noDataMessege="お知らせはありません"
          isLoading={notificationList.fetching}
          items={notificationList.data?.GetNotificationList?.Data || []}
          previousPage={PagePath.Notice}
        />
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          fetchApi={() => {}}
          totalCount={notificationList.data?.GetNotificationList?.TotalCount || 0}
          perPageCount={perPageCount}
        />
      </div>
    </>
  );
};
